import { FC } from "react";
import {
  AssistanceEvent,
  AssistanceType,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/AssistanceType";
import { TrainIndicator } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/TrainIndicator";
import { Text } from "shared/components/Spor";

type ExpandableHeaderProps = {
  assistanceEvent: AssistanceEvent;
};

export const ExpandableHeaderContent: FC<ExpandableHeaderProps> = ({
  assistanceEvent,
}) => {
  const firstStop = assistanceEvent.affectedStops.at(0)?.name;
  const lastStop = assistanceEvent.affectedStops.at(-1)?.name;
  const moreThanOneStop = assistanceEvent.affectedStops.length > 1;

  return (
    <>
      <AssistanceType eventType={assistanceEvent.type} />
      <div>
        <TrainIndicator
          trainNumber={assistanceEvent.trainIdentifier.identifier}
        />
      </div>
      {firstStop && <Text variant="xs">{firstStop}</Text>}
      {moreThanOneStop && lastStop && <Text variant="xs">{lastStop}</Text>}
    </>
  );
};
